module.exports = __webpack_public_path__ + "img/png02.a18f7260.png";